import {useContext, useEffect, useMemo} from 'react';
import {BackgroundEditor} from '~/common/FabricInvitation/EventCreateDesign/components/Background/BackgroundEditor';
import {BackgroundEditorMobile} from '~/common/FabricInvitation/EventCreateDesign/components/Background/Mobile/BackgroundEditorMobile';
import {Sections} from '~/common/FabricInvitation/EventCreateDesign/constants';
import {useEnvelopeContext} from '~/common/FabricInvitation/EventCreateDesign/contexts/EnvelopeContext';
import {EventCreateContext} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';
import {OverlayAnimation} from '~/common/OverlayAnimation/OverlayAnimation';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';

export const BackgroundContainer = () => {
  const isLargishAndUp = useIsLargishAndUp();
  const {effectVideo} = useContext(EventCreateContext);
  const {setCardProps, setEnvelopeProps} = useEnvelopeContext();

  const effectAnimation = useMemo(
    () => <OverlayAnimation fixed autoPlay effectVideo={effectVideo} />,
    [effectVideo]
  );

  useEffect(() => {
    setCardProps({redirectTo: Sections.CARD_DESIGN});
    setEnvelopeProps({
      redirectTo: Sections.ENVELOPE_LINER,
      type: isLargishAndUp ? 'flap_down_image' : 'blank',
      showLiner: true,
    });
  }, [isLargishAndUp, setCardProps, setEnvelopeProps]);

  return (
    <>
      {isLargishAndUp ? <BackgroundEditor /> : <BackgroundEditorMobile />}
      {effectAnimation}
    </>
  );
};
